import { State } from 'flow/types/State';

export const selectAccessToken = (state: State) =>
    state.integrationAccess.getIn(['createdToken', 'accessToken'], '');

export const selectDomains = (state: State) =>
    state.integrationAccess.get('domains');

export const selectTokens = (state: State) =>
    state.integrationAccess.get('tokens');
